var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgermenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hamburgermenu",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.7 19.6",
    style: {
      enableBackground: "new 0 0 26.7 19.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#202020;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_01",
    className: "st0",
    d: "M1.9,0.3h23c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5h-23C1,3.3,0.4,2.6,0.4,1.8S1,0.3,1.9,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_02",
    className: "st0",
    d: "M1.9,8.3h23c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5h-23c-0.8,0-1.5-0.7-1.5-1.5 C0.4,9,1,8.3,1.9,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_03",
    className: "st0",
    d: "M1.9,16.3h23c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5h-23c-0.8,0-1.5-0.7-1.5-1.5 C0.4,17,1,16.3,1.9,16.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgermenu);
export default __webpack_public_path__ + "static/media/hamburgermenu.4b0643a8b0cc9487ba127b364e386897.svg";
export { ForwardRef as ReactComponent };